/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type CustomerTransferOrderPaginatedProperty =
  typeof CustomerTransferOrderPaginatedProperty[keyof typeof CustomerTransferOrderPaginatedProperty];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CustomerTransferOrderPaginatedProperty = {
  INSTRUCTION_STATUS: 'INSTRUCTION_STATUS',
  BANK_NAME: 'BANK_NAME',
  FROM_PRODUCT_NAME: 'FROM_PRODUCT_NAME',
  TO_PRODUCT_NAME: 'TO_PRODUCT_NAME',
  CUSTOMER_FIRST_NAME: 'CUSTOMER_FIRST_NAME',
  CUSTOMER_LAST_NAME: 'CUSTOMER_LAST_NAME',
  BALANCE: 'BALANCE',
  CREATED_AT: 'CREATED_AT',
  UPDATED_AT: 'UPDATED_AT',
} as const;
